import React from "react";
import { toast } from "react-toastify";
import {
  Container,
  Dropdown,
  Tab,
  Nav,
  OverlayTrigger,
  Tooltip,
  Button,
  Spinner,
  Tabs,
  Form,
  Col
} from "react-bootstrap";  
import {IWorkOrderPermissionRequestDto, IWorkOrderRequestDto } from "../../Common/Contracts/IWorkOrder";
import { WorkOrder } from "../../Common/Services/WorkOrder";
import { resolve, reject } from "q";
import WorkOrderSlideOut from "../Workorder/WorkOrderSlideOut";
import { AssetMaintenance } from "./AssetMaintenance";
import { AssetWorkOrder } from "./AssetWorkOrder";
import AutosizeInput from "react-input-autosize";
import { Utils } from "../../Common/Utilis";
import { confirmAlert } from "react-confirm-alert";
import { Facility } from "../../Common/Services/Facility";
import AssetHistoryBox from "./AssetHistoryBox";
import DatePicker from "react-datepicker";
import { SingleSearchDropdownList } from "../../Common/Components/SingleSearchDropdownList";
import Dropzone from 'react-dropzone';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faFileCsv, faFileExcel, faFileImage, faFilePdf, faFilePowerpoint, faFileText, faFileWord } from "@fortawesome/free-solid-svg-icons";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import Joi from "joi-browser";
export class AssetSlideOut extends React.Component<any, any> {
  private wororderSlideOut: any;
  private refLocationWorkOrder: any;
  private refLocationAsset: any;
  private refLocationMaintenance: any;
  private slideOutRef: any;
  private input: any;
  private childHistoryBox: any;

  constructor(props: any) {
    super(props);
    this.wororderSlideOut = React.createRef();
    this.refLocationWorkOrder = React.createRef();
    this.refLocationAsset = React.createRef();
    this.refLocationMaintenance = React.createRef();
    this.slideOutRef = React.createRef();
    this.input = React.createRef();
    this.childHistoryBox = React.createRef();
    
    this.state = {
        isReload: false,  
        locationName : this.props.parentstate.roomName,
        locationType : this.props.parentstate.roomType,
        tableData: [],
        sortingOrder: "asc",
        sortingField: "location",
        locationTypesList: [],
        assetTypesList: [],
        assignToListRightPanel: [],
        parentRowData: [],
        assignToList: [],
        isDataSaving:false,
        isSlideOut: false,
        bdrValue:false,
        PageType: "Asset",
        hidValue : this.props.hid,
        locationId : this.props.parentstate.roomID,
        name: this.props?.parentstate?.assetName,
        workorderPermission: "",
        activeTab: "Details",
        // workordertbl: 0
        tbl : 0,
        lastWorkId : "",
        type: "",
        countLoader: false,
        count:0,
        assetTypes:this.props?.assetTypes?.map(({ assetTypeId, assetTypeName }) => ({id: assetTypeId,name: assetTypeName,})) || [],
        assetTypeId: this.props?.parentstate?.assetTypeId,
        description: this.props?.parentstate?.description,
        selectedInstallationDate: this.props.parentstate?.assetInstallationDate,
        selectedManufactureDate: this.props.parentstate?.assetManufactureDate,
        selectedPurchaseDate:this.props.parentstate?.assetPurchaseDate,
        selectedStartDate:this.props.parentstate?.assetStartDate,
        selectedEndDate:this.props.parentstate?.assetEndDate,
        newSelectfiles: [],
        newSelectfiles2: [],
        savedfiles: [],
        savedfiles2: [],
        serialNumber:this.props.parentstate?.assetSerialNumber,
        modelNumber:this.props.parentstate?.assetModelNumber,
        manufacturer:this.props.parentstate?.assetManufacturer,
        purchaseCost:this.props.parentstate?.assetPurchaseCost,
        expectedLifespan:this.props.parentstate?.assetExpectedLifespan,
        startDate:this.props.parentstate?.assetStartDate,
        endDate:this.props.parentstate?.assetEndDate,
        provider:this.props.parentstate?.assetProvider,
        terms:this.props.parentstate?.assetTerms,
        height:this.props.parentstate?.assetHeight,
        width:this.props.parentstate?.assetWidth,
        depth:this.props.parentstate?.assetDepth,
        weight:this.props.parentstate?.assetWeight,
        powerRequirements:this.props.parentstate?.assetPowerRequirements,
        energyEfficiencyRating:this.props.parentstate?.assetEnergyEfficiencyRating,
        operatingRequirements:this.props.parentstate?.assetOperatingRequirements,
        company:this.props.parentstate?.assetCompany,
        pointofContact:this.props.parentstate?.assetPointOfContact,
        address:this.props.parentstate?.assetAddress,
        phone:this.props.parentstate?.assetPhone,
        email:this.props.parentstate?.assetEmail,
        fileSize: 5242880,
        moreActionFileUpload1: [
          { name: "Delete", eventKey: "delete" },
          { name: "Download", eventKey: "download" }
        ],
        moreActionFileUpload2: [
          { name: "Delete", eventKey: "delete" },
          { name: "Download", eventKey: "download" }
        ],
        lastSavedState: {},
        errors: "",
    };
  }

  componentDidMount() {
    this.getrooms();
    this.GetFacilityAsset();
    this.getAssignUserList();
    this.GetWorkOrderPermission();
    this.GetUploadFileList();
    this.refLocationWorkOrder.current.getWorkOrder();
    this.slideOutRef.current.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    this.slideOutRef.current.removeEventListener("scroll", this.handleScroll);
  }
  handleScroll = () => {
    if (this.slideOutRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = this.slideOutRef.current;
        // If user reaches the bottom of the scroll container
        if (scrollTop + clientHeight >= scrollHeight - 10) {
            
         this.childHistoryBox.checkScrollPosition();
        }
    }
};

  closeSlideOut = () => {
    this.props?.handleHideSlideout(true);
  };

  closeLocationSlideOut = (row: any) => {
    this.setState({isSlideOut : true,parentRowData:row});
    setTimeout(() => {
      this.slideOutRef.current.scrollTo({
        top: 0,
        behavior: "instant",
      });
    });
    // this.props?.handleHideSlideoutforworkorder(this.state.isReload,row);
  }

  handleClick = () => {
    this.setState({ bdrValue: true });
  };

  handleBlurAutoSize = () => {
    this.setState({ bdrValue: false ,   name: this.state.name.trimRight(),}, ()=>{
      this.setState({changeValue: this.state.name  === this.props?.parentstate?.assetName ? false:true})
    });
  };

  changesAfterSave = (row: any) =>{

     if(this.state.isSlideOut){
      this.setState({isSlideOut : false},()=>{
        this.setState({isSlideOut : true,parentRowData:row});
      });     
     }else{
      this.setState({isSlideOut : true,parentRowData:row});
     }
  }

  closeworkorderSlideout = (value) => {
  
    if(this.wororderSlideOut.current.state.changeValue === true){
      this.setState({isSlideOut: value,activeTab: "work-orders",type: "table"} , () => {
        this.wororderSlideOut.current.isValidateModelPoupTab("sideClick");
      });
    }
    else{
    this.setState({isSlideOut: value, activeTab: "work-orders" , type: "table"}, () => {
      if (this.refLocationWorkOrder.current !== null) {
        this.refLocationWorkOrder.current.getWorkOrder();
      }
    });
  }
  };

  closeSlideOutWithConfirmation = () => {
    if (this.state.changeValue) {
      this.isValidateModelPoupTab();
    }
    else if(this.state.isSlideOut === false){
      this.closeSlideOut();
    }
    
  };

  
  isValidateModelPoupTab() {
    confirmAlert({
      title: "Unsaved confirmation",
      message:
        "You have unsaved changes on this page. Do you want to leave this page and discard your changes?",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.isChangeUnsaved(),
        },
        {
          label: "No",
          onClick: () => reject(),
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  }

  isChangeUnsaved = () => {
    this.setState({ changeValue: false }, () => {
      this.disccardChanges(true);
    });
  };

  slideOutClosewithDiscardChanges = (value) => {
    this.setState({isSlideOut : value});
  
  }

  getrooms = () => {
    let hotelID = Number(this.state.hidValue);
   WorkOrder.GetFacilityRooms(hotelID)
       .then(async (result: any | null) => {
           let DayApproveData: any = [];
           
           if (result != null && result.length > 0) {
               let Data = result.map(x => {
                   return { id: x?.roomID, name: x?.roomName };
               })

               this.setState({
                 locationTypesList: Data
               });
               this.setState({locationSearchTypesList:[]},()=>{
                 this.setState({ locationSearchTypesList: [{ id: -1, name: "All" },...Data] });
               })
              
           } else {
               this.setState({
                 locationTypesList: []
               });
           }
           resolve();
       })
       .catch((err) => {
           Utils.toastError(`Server Error, ${err}`, {
           });

           reject();
       });
}

GetFacilityAsset = () => {
  let hotelID = Number(this.state.hidValue);
    WorkOrder.GetFacilityAsset(hotelID)
        .then(async (result: any | null) => {

            if (result != null && result.length > 0) {
                let Data = result.map(x => {
                    return { id: x?.roomID, name: x?.roomName, locationID: x?.locationID };
                })
                this.setState({ assetTypesList: Data });
              // this.setState({ assetTypesList: [{ id: 0, name: "Select an asset" }, ...Data] });
            } else {
                //this.setState({ assetTypesList: [{ id: 0, name: "Select an asset" }] });
                this.setState({ assetTypesList: [] });
            }
            resolve();
        })
        .catch((err) => {
            Utils.toastError(`Server Error, ${err}`, {
            });

            reject();
        });
}

getAssignUserList() {

  let request = {} as IWorkOrderRequestDto;
  request.hotelID = Number(this.state.hidValue);
  request.type = "AssignUsers";
  WorkOrder.GetFcUserDetailsList(request)
    .then(async (result: any | null) => {
     
      if (result != null && result.length > 0) {
        let Data = result.map(x => {
          return { id: x?.user_UniqueID, name: x?.employee };
        })

        this.setState({ assignToList: [] }, () => {
          this.setState({ assignToList: [{ id: -1, name: "All" }, ...Data] });
          this.setState({assignToListRightPanel:Data});
          // this.setState({ assignToListToChild: [{ id: -1, name: "Select a technician" }, ...Data] });
        })

      } else {
        this.setState({ assignToList: [{ id: -1, name: "All" }],assignToListRightPanel:[]});
        
      }
      resolve();
    })
    .catch((err) => {
      Utils.toastError(`Server Error, ${err}`, {
      });

      reject();
    });
}

GetWorkOrderPermission = () =>  {
  let request = {} as IWorkOrderPermissionRequestDto;
  WorkOrder.GetWorkOrderPermission(request)
    .then(async (result: any | null) => {
      let DayApproveData: any = [];
      if (result != null && result.length > 0) {  
        console.log("result",result[0].permission);
        // console.log();
        
        if(result[0].permission === "Yes")
        {
          this.setState({workorderPermission: "Yes"});
        }
        else{
          this.setState({workorderPermission: "No"});
        }
      }
      resolve();
    })
    .catch((err) => {
      Utils.toastError(`Server Error, ${err}`, {         
      });
      
      reject();
    });
}

handleTabSelect= (selectedTab) => {

  console.log("selectedTab",selectedTab);
  this.setState({activeTab: selectedTab});
}

refeshTable=(workOrderID :any,type:any)=>{

  this.setState({lastWorkId:workOrderID,type:type});
  this.refLocationWorkOrder.current.getWorkOrder();
  // if (this.state.isDayDropDown) {
  //         this.getWorkOrderSummaryDetails("completed","");
  //       } else {
  //         this.getWorkOrderSummaryDetails("notcompleted","");
  //       }
  //     });
}

countUpdate = (count,countState) => {
    this.setState({count:count,countLoader:countState})
}

onFieldChange = (event,inputPosition) => {
  const { name, value } = event.target;
  const fieldsToTrim = [
    "name",
    "serialNumber",
    "modelNumber",
    "assetName",
    "purchaseCost",
    "expectedLifespan",
    "startDate",
    "endDate",
    "provider",
    "terms",
    "height",
    "width",
    "depth",
    "weight",
    "powerRequirements",
    "energyEfficiencyRating",
    "operatingRequirements",
    "company",
    "pointofContact",
    "address",
    "phone",
    "email",
  ];

  // Trim left spaces only for specified fields
  const trimmedValue = fieldsToTrim.includes(name) ? value.trimLeft() : value;
  let errors = { ...this.state.errors };
  if (name === "email") {
    if (!trimmedValue) {
      errors.email = ""; // Clear error if email is empty
    } else {
    const schema = Joi.string()
      .regex(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        "email"
      )
      .required()
      .max(200)
      .error((errors) => {
        return errors.map((error) => {
          switch (error.type) {
            case "string.base":
            // case "any.empty":
            //   return { message: "Email Address is required" };
            case "string.regex.name":
            case "string.max":
              return { message: "Please enter a valid email address format" };
            // default:
            //   return { message: "Invalid email format" };
          }
        });
      });

    const { error } = schema.validate(trimmedValue);
    errors.email = error ? error.details[0].message : ""; // Store validation error
   }
  }
  this.setState((prevState) => ({
    ...prevState,
    [name]: trimmedValue, // Update state dynamically
    errors,
    changeValue: prevState[name] !== trimmedValue, // Track value changes
  }));
};



disccardChanges = (isFromModal = false) => {
  this.setState(
    {
      isRefresh: true,
      changeValue: false,
      name: this.props?.parentstate?.assetName,
      description: this.state.lastSavedState?.description || this.props?.parentstate?.description,
      serialNumber: this.state.lastSavedState?.serialNumber || this.props?.parentstate?.assetSerialNumber,
      modelNumber: this.state.lastSavedState?.modelNumber || this.props?.parentstate?.assetModelNumber,
      manufacturer: this.state.lastSavedState?.manufacturer || this.props?.parentstate?.assetManufacturer,
      purchaseCost: this.state.lastSavedState?.purchaseCost || this.props?.parentstate?.assetPurchaseCost,
      expectedLifespan: this.state.lastSavedState?.expectedLifespan || this.props?.parentstate?.assetExpectedLifespan,
      // startDate: this.state.lastSavedState?.startDate || this.props?.parentstate?.assetStartDate,
      // endDate: this.state.lastSavedState?.endDate || this.props?.parentstate?.assetEndDate,
      provider: this.state.lastSavedState?.provider || this.props?.parentstate?.assetProvider,
      terms: this.state.lastSavedState?.terms || this.props?.parentstate?.assetTerms,
      height: this.state.lastSavedState?.height || this.props?.parentstate?.assetHeight,
      width: this.state.lastSavedState?.width || this.props?.parentstate?.assetWidth,
      depth: this.state.lastSavedState?.depth || this.props?.parentstate?.assetDepth,
      weight: this.state.lastSavedState?.weight || this.props?.parentstate?.assetWeight,
      powerRequirements: this.state.lastSavedState?.powerRequirements || this.props?.parentstate?.assetPowerRequirements,
      energyEfficiencyRating: this.state.lastSavedState?.energyEfficiencyRating || this.props?.parentstate?.assetEnergyEfficiencyRating,
      operatingRequirements: this.state.lastSavedState?.operatingRequirements || this.props?.parentstate?.assetOperatingRequirements,
      company: this.state.lastSavedState?.company || (this.props?.parentstate?.assetCompany ?? ""),
      pointofContact: this.state.lastSavedState?.pointofContact || (this.props?.parentstate?.assetPointOfContact ??""),
      address: this.state.lastSavedState?.address || (this.props?.parentstate?.assetAddress ?? ""),
      phone: this.state.lastSavedState?.phone || (this.props?.parentstate?.assetPhone ?? ""),
      email: this.state.lastSavedState?.email || (this.props?.parentstate?.assetEmail ?? ""),
      selectedInstallationDate: this.state.lastSavedState?.selectedInstallationDate || this.props?.parentstate?.assetInstallationDate,
      selectedManufactureDate: this.state.lastSavedState?.selectedManufactureDate || this.props?.parentstate?.assetManufactureDate,
      selectedPurchaseDate: this.state.lastSavedState?.selectedPurchaseDate || this.props?.parentstate?.assetPurchaseDate,
      selectedStartDate: this.state.lastSavedState?.selectedStartDate || this.props?.parentstate?.assetStartDate,
      selectedEndDate: this.state.lastSavedState?.selectedEndDate || this.props?.parentstate?.assetEndDate,
      errors:"",
    },
    () => {
      this.setState({ isRefresh: false });
    }
  );

  if (isFromModal) {
    this.closeSlideOut();
  }
 
};

handleSave =()=>{
      const formatDate = (date) => {
        if (!date) return "";  
        return new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }).format(new Date(date)); 
    };
    let data:any = {}
    data.AssetId=this.props.parentstate?.assetId;
    data.RoomId= (this.state.locationId && this.state.locationId !== 0) ? this.state.locationId : this.props.parentstate?.roomId;
    data.AssetName= this.state.name;
    data.AssetTypeId= this.state.assetTypeId == 0 ? this.props.parentstate?.assetTypeId : this.state.assetTypeId;
    data.AssetDescription=  this.state.description ? this.state.description : this.props.parentstate?.description;
    data.AssetSerialNumber= this.state.serialNumber;
    data.AssetModelNumber= this.state.modelNumber;
    data.AssetManufacturer= this.state.manufacturer;
    data.AssetPurchaseCost= this.state.purchaseCost;
    data.AssetExpectedLifespan= this.state.expectedLifespan;
    data.AssetProvider= this.state.provider;
    data.AssetTerms= this.state.terms;
    data.AssetHeight= this.state.height;
    data.AssetWidth= this.state.width;
    data.AssetDepth= this.state.depth;
    data.AssetWeight= this.state.weight;
    data.AssetPowerRequirements= this.state.powerRequirements;
    data.AssetEnergyEfficiencyRating= this.state.energyEfficiencyRating;
    data.AssetOperatingRequirements= this.state.operatingRequirements;
    data.AssetCompany= this.state.company;
    data.AssetPointOfContact= this.state.pointofContact;
    data.AssetAddress= this.state.address;
    data.AssetPhone= this.state.phone;
    data.AssetEmail= this.state.email;

    data.AssetInstallationDate= formatDate(this.state.selectedInstallationDate);
    data.AssetManufactureDate= formatDate(this.state.selectedManufactureDate);
    data.AssetPurchaseDate= formatDate(this.state.selectedPurchaseDate);
    data.AssetStartDate= formatDate(this.state.selectedStartDate);
    data.AssetEndDate= formatDate(this.state.selectedEndDate);
    

    if (!this.state.name) {
      let errorMessage = "Please enter Asset Name";
      Utils.toastError(errorMessage, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "InvoiceSlideout",
      });
      
      return
    }

    this.setState({isDataSaving:true})
  if(!this.state.errors.email)
  {
    Facility.SaveAssets(data)
    .then((result: any) => {
      
        this.setState({state: { ...this.state.state, ...result }, isDataSaving: false,changeValue:false,lastSavedState: result.result })
        //  this.setState({isDataSaving:false})
        //  this.props?.handleHideSlideout(true);

         toast.success(`Asset updated successfully.`, {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "addGarnishment",
          });
          this.refreshHistoryTab();
      
     
    }).catch((error)=>{
        this.setState({isDataSaving:false})

        if(error.response.data == 'Asset Name already in use. Please provide a different name.')
        {

            Utils.toastError(error?.response?.data, {
              position: toast.POSITION.BOTTOM_RIGHT,
              // containerId: "addGarnishment",
            });
      
           
        }
        else{
         Utils.toastError(error.response.data, {
            position: toast.POSITION.BOTTOM_RIGHT,
            // containerId: "addGarnishment",
          });

          this.props?.handleHideSlideout(true);
        }
   
    })
  }
  else{
        Utils.toastError(this.state.errors.email, {
            position: toast.POSITION.BOTTOM_RIGHT
        });
        this.setState({changeValue:false, isDataSaving:false})
  }
  
}
handleExport = () =>
    {
      Facility.GetAssetHestoryDetails(this.state.hidValue,this.props.parentstate.assetId)
        .then(async (result: any | null) => {          
          this.downloadHistory(result)
          resolve();
        })
        .catch((err) => {
          Utils.toastError(`Server Error, ${err}`, {
          });
  
        reject();
        });
    }
    downloadHistory = (result) => {
      const name = this.state.name.replace(/[^a-zA-Z0-9]/g, ""); 
      const currentDate = new Date().toISOString().split("T")[0]; 
      const fileName = `${name || "Asset"}_History_${currentDate}.txt`;
      const formattedData = this.formatHistoryData(result);
      const blob = new Blob([formattedData], { type: "text/plain" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(url);
      toast.success("File has been exported successfully.", {
          position: toast.POSITION.BOTTOM_RIGHT,
      });
  };
  formatHistoryData = (data) => {
      return data.map((element) => {
          let message = "";     
          switch (element.columnName) {
            case "CreatedAsset":
              message = `${element.createBy} created Asset: ${element.newValue}`;
              break;
            case "AssetRoomId":
              message = `${element.createBy} associated Asset with Location ${element.newValue || "None"}`;
              break;
            case "AssetNameChanged":
              message = `${element.createBy} changed Asset name from ${element.oldValue || "None"} to ${element.newValue || "None"}`;
              break;
            case "WorkOrderAssociation":
              message = `${element.createBy} associated Asset with Work Order ${element.newValue || "None"}`;
              break;
            case "WorkOrderRemoved":
              message = `${element.createBy} removed Asset from Work Order ${element.oldValue || "None"}`;
              break;
            case "RenameLocationName":
              message = `${element.createBy} renamed Location from ${element.oldValue || "None"} to ${element.newValue || "None"}`;
              break;
            case "RenameAssetType":
              message = `${element.createBy} renamed Asset Type from ${element.oldValue || "None"} to ${element.newValue || "None"}`;
              break;
            case "RenameWorkOrder":
              message = `${element.createBy} renamed Work Order from ${element.oldValue || "None"} to ${element.newValue || "None"}`;
              break;
              case "AssetTypeId":
                message = `${element.createBy} changed Asset Type of Asset from ${element.oldValue || "None"} to ${element.newValue || "None"}`;
                break;
              case "LocationChange":
                  message = `${element.createBy} changed Location of Asset from ${element.oldValue || "None"} to ${element.newValue || "None"}`;
                  break;
              case "AssetDescription":
                message = `${element.createBy} updated Description from ${element.oldValue || "None"} to ${element.newValue || "None"}`;
                break;
            default:
              message = `${element.createBy} updated  Asset details from ${element.oldValue || "None"} to ${element.newValue || "None"}`;
              break;
          }
          return `${element.modifyedDate}  ${message}`;
      }).join("\n");
  };
  refreshHistoryTab = () =>{
    if (this.childHistoryBox) {
        this.childHistoryBox.reloadHistory();
    }
  }
  descriptionChange = (e: any) => {

    let value = e.target.value;
    this.setState({ changeValue: true, description: value });

    // e.target.style.height = 'auto';
    // e.target.style.height = e.target.scrollHeight + 'px';
}
handleSelectedItem = (controlID: any, id: any) => {
  if (controlID === 1) {
    if(this.state.count > 0){
      // this.setState({ changeValue: false });
      let msg = "This asset is associated with one or more active work orders. You cannot change the location while the asset is associated with an active work order. Please complete the work order and then try to change the location again.";
          Utils.toastError(msg, {
              position: toast.POSITION.BOTTOM_RIGHT,
          });
          this.setState({ isRefresh: !this.state.isRefresh }); // Re-render dropdown to reset selection
          return;
    }
    else{
      this.setState({ locationId: id });
      this.setState({ changeValue: true });
    }
  }
  if (controlID === 2) {
      this.setState({ assetTypeId: id });
      this.setState({ changeValue: true });
  }
};
isValidDate = (date) => {
  if (!(date instanceof Date) || isNaN(date.getTime())) {
      return false;
  }
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  if (year < 1900 || year > 2100 || month < 1 || month > 12 || day < 1 || day > 31) {
      return false;
  }
  return true;
};
handleSelectDate = (date,eventType,selectedType) => {
  // if (!this.isValidDate(date)) {
  //   this.setState({ 
  //     selectedInstallationDate: date, 
  //     selectedManufactureDate: date,
  //     selectedPurchaseDate:date, 
  //     selectedStartDate:date,
  //     selectedEndDate:date,
  //     changeValue: false });
  //   return;
  // }
  const stateUpdate = {
    changeValue: true,
    selectedInstallationDate: selectedType === "InstallationDate" ? date : this.state.selectedInstallationDate,
    selectedManufactureDate: selectedType === "ManufactureDate" ? date : this.state.selectedManufactureDate,
    selectedPurchaseDate: selectedType === "PurchaseDate" ? date : this.state.selectedPurchaseDate,
    selectedStartDate: selectedType === "StartDate" ? date : this.state.selectedStartDate,
    selectedEndDate: selectedType === "EndDate" ? date : this.state.selectedEndDate,
  };
  this.setState(stateUpdate);
}
onFileChange = (event: any, mode: number) => {
  let newFiles: any = [];
  if (event.target.files.length > 0) {
    for (let i = 0; i < event.target.files.length; i++) {
      let fileRow = event.target.files[i];
      newFiles.push(fileRow);
    }
    this.onDrop(newFiles, mode);
  }
};
onDrop = (filelist: any, mode: number) => {
          let size = this.state.fileSize;//5242880//5MB
          let newfiles: any = [];
          let files: any = [];
          let isReturn = true;
          let filestext = "";
          let filesizeval = Number(Number(this.state.fileSize) / (1024 * 1024))
          filelist.forEach(element => {
              if (element.size > size) {
                  filestext = filestext + element.name + ","
                  isReturn = false;
              }
          })
  
          if (!isReturn) {
              let msg = "One or more files are greater than " + filesizeval + "MB.";
              Utils.toastError(msg, {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  containerId: "InvoiceSlideout",
              });
          }
          let isInvalidFile = false;
          filelist.forEach(element => {
              if ((element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'pdf'
                  || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'doc'
                  || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'docx'
                  || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'xls'
                  || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'xlsx'
                  || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'csv'
                  || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'txt'
                  || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'bmp'
                  || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'tif'
                  || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'ppt'
                  || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'pptx'
                  || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'rtf'
                  || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'jpg'
                  || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'jpeg'
                  || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'png'
                  || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'msg'
                  || element.name.substring(element?.name.lastIndexOf(".") + 1, element?.name.length).toLowerCase() === 'eml'
              ) && element.size <= size) {
                  newfiles.push(element)
                  files.push(element)
              } else {
                  isInvalidFile = true;
              }
          });
          if (isInvalidFile && isReturn) {
              let msg = "";
              if (filelist.length === 1) {
                  msg = "This file type is not supported."
              } else {
                  msg = "Some files are not supported."
              }
              Utils.toastError(msg, {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  containerId: "InvoiceSlideout",
              });
          }
          let newfileData = mode == 1 ? [...this.state.newSelectfiles] : [...this.state.newSelectfiles2];
          for (let i = 0; i < newfiles.length; i++) {
              newfiles[i].etype = "newfile";
              newfileData.push(newfiles[i]);
          }
          let fileUploadedType = mode==1 ? "Warranty" : "Technical Specifications";
          this.setState(
            mode == 1 
                ? { files, newSelectfiles: newfileData } 
                : { files, newSelectfiles2: newfileData }, 
            () => {
                if (files.length > 0) {
                    this.handleSaveFiles(fileUploadedType);
                }
            }
        );
  }
  GetUploadFileList = () => {

        let requestlist: any = {};
        requestlist.hid = Number(this.props.hid);
        requestlist.assetId = Number(this.props.parentstate?.assetId);

        Facility.GetUploadFileList(requestlist)
            .then(async (result: any | null) => {
                if (result !== null) {
                  let warrantyFiles = result.filter(ele => ele.fileUploadedType.trim().toLowerCase() == "warranty");
                  let technicalFiles = result.filter(ele => ele.fileUploadedType.trim().toLowerCase() == "technical specifications");
  
                    for (let i = 0; i < result.length; i++) {
                        this["myRef" + i] = React.createRef();
                    }
                    this.setState({ savedfiles: [], savedfiles2: [] }, () => {
                      this.setState({
                          savedfiles: warrantyFiles, // Warranty files
                          savedfiles2: technicalFiles, // Technical Specification files
                          files: [],
                          newSelectfiles: [],
                          newSelectfiles2: [],
                          isSpinner: false,
                      });
                  });
                }
                resolve();
            })
            .catch((error) => {
                reject();
            });
    };
  
  
handleSaveFiles = (fileUploadedType) => {
    this.setState({ isSpinner: true });
    let request: any = {};
    request.hid = this.props.hid;
    request.assetId = this.props.parentstate?.assetId;
    request.fileUploadedType = fileUploadedType;
    let newfileData = fileUploadedType == "Warranty" ? [...this.state.newSelectfiles] : [...this.state.newSelectfiles2];
    Facility.SaveAssetFile(request, newfileData)
        .then(async (result: any | null) => {
            if (result !== null) {

                if (result.saveStatus === "Success") {

                    this.GetUploadFileList();
                    this.setState({ isSpinner: false });
                    toast.success("Files saved  successfully.", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        containerId: "InvoiceSlideout",
                    });
                    // this.getHistoryTab();
                    // this.GetPDFViewUploadFileList();


                }
                else {
                    this.setState({ isSpinner: false });
                    Utils.toastError(result.message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        containerId: "InvoiceSlideout",
                    });
                }
            }

            resolve();
        })
        .catch((error) => {
            this.setState({ changeValue: false, isSpinner: false });
            reject();
        });

}
DownloadAssetFile = (file: any) => {
  Facility.DownloadAssetFile(file)
        .then(async (result: any | null) => {
            resolve();
        })
        .catch((error) => {
            reject();
        });
    };
isDeleteWorkOrder(fileUniqueNo) {
  Facility.DeleteAssetFile(fileUniqueNo)
      .then(async (result: any | null) => {
          if (result.saveStatus === "Success") {
              toast.success(`Attachment deleted successfully.`, {
                  position: toast.POSITION.BOTTOM_RIGHT,
              });
              this.setState({ isOpenViewer: false });
          }
          this.GetUploadFileList();
          resolve();
      })
      .catch((error) => {
          reject();
      });
}
handleSelectFileUpload = (eventKey: any, file, index) => {
      if (eventKey === "delete") {
          this.setState({ deleteFile: "Yes" });
          let request: any = {};
          // request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));
          let masg = "";
          masg = "Are you sure you want to delete this Attachment?"
          confirmAlert({
              title: "Delete Attachment",
              message: masg,
              buttons: [
                  {
                      label: "Yes",
                      onClick: () => this.isDeleteWorkOrder(file.fileUniqueNo),
                  },
                  {
                      label: "No",
                      onClick: () => reject(),
                  },
              ],
              closeOnEscape: false,
              closeOnClickOutside: false,
              overlayClassName: "delete-file-confirmation"
          });
      }
      else if (eventKey === "download") {
          this.DownloadAssetFile(file);
      }
  }
  render() { 
    const files1 = this.state.savedfiles?.map((file, index) => (
                <>
                    <li key={file.filename}>
                        <div className="d-flex align-items-center justify-content-start">
                            <div className="icon">
                                {(file?.type)?.split('/')[0] === 'image' && (
                                    <FontAwesomeIcon icon={faFileImage} />
                                )}
                                {(file?.filename.substring(file?.filename.lastIndexOf(".") + 1, file?.filename.length)) === 'pdf' && (
                                    <FontAwesomeIcon icon={faFilePdf} />
                                )}
                                {['png', 'jpg', 'jpeg', 'bmp'].includes(file?.filename?.substring(file?.filename.lastIndexOf(".") + 1).toLowerCase()) && (
                                    <FontAwesomeIcon icon={faFileImage} />
                                )}
                                {['doc', 'docx', 'word'].includes(file?.filename?.substring(file?.filename.lastIndexOf(".") + 1).toLowerCase()) && (
                                    <FontAwesomeIcon icon={faFileWord} />
                                )}
                                {['xlsx', 'xls'].includes(file?.filename?.substring(file?.filename.lastIndexOf(".") + 1).toLowerCase()) && (
                                    <FontAwesomeIcon icon={faFileExcel} />
                                )}
                                {['ppt', 'pptx'].includes(file?.filename?.substring(file?.filename.lastIndexOf(".") + 1).toLowerCase()) && (
                                    <FontAwesomeIcon icon={faFilePowerpoint} />
                                )}
                                {(file?.filename.substring(file?.filename.lastIndexOf(".") + 1, file?.filename.length)) === 'txt' && (
                                    <FontAwesomeIcon icon={faFileText} />
                                )}
                                {(file?.filename.substring(file?.filename.lastIndexOf(".") + 1, file?.filename.length)) === 'csv' && (
                                    <FontAwesomeIcon icon={faFileCsv} />
                                )}
                                {!['image', 'pdf', 'xlsx', 'xls', 'csv', 'png', 'word', 'jpg', 'jpeg', 'bmp', 'txt', 'doc', 'docx', 'ppt', 'pptx'].includes(file?.type?.split('/')[0] === 'image'
                                    ? 'image'
                                    : file?.filename?.substring(file?.filename.lastIndexOf(".") + 1)?.toLowerCase()
                                ) && (
                                        <FontAwesomeIcon icon={faFile} />
                                    )}
                            </div>
                            <div className="file-info d-flex align-items-center" >
                                <div className="name-loader d-flex align-items-center">
                                    <div className="name">
                                        <EllipsisWithTooltip placement="bottom">
                                            <div className="full-name" >{file.filename}</div>
                                        </EllipsisWithTooltip>
                                        {/* <div className="details">{file.createDate} - {file.pageno} Page</div> */}
                                    </div>
                                </div>
                                <div className="formate-percentage">
                                    <span className="formate d-flex justify-content-center align-items-center">{(file?.filename.substring(file?.filename.lastIndexOf(".") + 1, file?.filename.length))}</span>
                                </div>
                            </div>
                            <div className="action">
                                {/* {!this.state.bulkSelect && ( */}
                                <Dropdown className="more-action" alignRight onSelect={(event: any) => this.handleSelectFileUpload(event, file, index)}>
                                    <Dropdown.Toggle className="btn-outline-primary btn btn-primary more" id="dropdown-more">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                                            <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                                            <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                                        </svg>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {this.state.moreActionFileUpload1?.map(
                                            (item: any, idx: any) => (
                                                <>
                                                    <Dropdown.Item
                                                        eventKey={this.state.moreActionFileUpload1[idx].eventKey}
                                                        key={idx}
                                                        disabled={this.props.createEditPermission}
                                                    >
                                                        {this.state.moreActionFileUpload1[idx].name}
                                                    </Dropdown.Item>
                                                </>
                                            )
                                        )}
                                    </Dropdown.Menu>
                                </Dropdown>
                                {/* )} */}
                            </div>
                        </div>
                    </li>
                </>
      ));
    
     const files = this.state.newSelectfiles?.map((file, index) => (
          <>
              <li key={file.name}>
                  <div className="d-flex align-items-center justify-content-start">
                      <div className="icon">
                          {(file?.type)?.split('/')[0] === 'image' && (
                              <FontAwesomeIcon icon={faFileImage} />
                          )}
                          {(file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) === 'pdf' && (
                              <FontAwesomeIcon icon={faFilePdf} />
                          )}
                          {(file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) === 'xlsx' && (
                              <FontAwesomeIcon icon={faFileExcel} />
                          )}
                          {(file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) === 'csv' && (
                              <FontAwesomeIcon icon={faFileCsv} />
                          )}
                          {(file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) === 'word' && (
                              <FontAwesomeIcon icon={faFileWord} />
                          )}
                          {(((file?.type)?.split('/')[0] !== 'image') &&
                              ((file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) !== 'pdf') &&
                              ((file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) !== 'xlsx')
                              && ((file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) !== 'csv')
                              && ((file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) !== 'word'))
                              && (
                                  <FontAwesomeIcon icon={faFile} />
                              )}
                      </div>
                      <div className="file-info d-flex align-items-center">
                          <div className="name-loader d-flex align-items-center">
                              <div className="name">
                                  <EllipsisWithTooltip placement="bottom">
                                      {/* <div className="full-name" onClick={() => { this.handlePreview(file) }}>{file.name}</div> */}
                                      <div className="full-name">{file.name}</div>
                                  </EllipsisWithTooltip>
                              </div>
                          </div>
                          <div className="formate-percentage">
                              <span className="formate d-flex justify-content-center align-items-center">
                                  {(file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length))}
                              </span>
                          </div>
                      </div>
                      <div className="action">
                          {/* <button className="btn-outline-primary remove-pdf more btn btn-primary" onClick={() => { this.handleSelectFileUpload("TempDelete", file, 0) }} >
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"></path></svg>
                              
                          </button> */}

                          {this.state.isSpinner && (
                              <button className="btn-outline-primary remove-pdf more btn btn-primary">
                                  <Spinner
                                      className="mr-2"
                                      as="span"
                                      animation="border"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                  />
                              </button>
                          )}


                      </div>
                  </div>
              </li>
          </>
      ));

      const files2 = this.state.savedfiles2?.map((file, index) => (
        <>

            <li key={file.filename}>
                <div className="d-flex align-items-center justify-content-start">
                    <div className="icon">
                        {(file?.type)?.split('/')[0] === 'image' && (
                            <FontAwesomeIcon icon={faFileImage} />
                        )}
                        {(file?.filename.substring(file?.filename.lastIndexOf(".") + 1, file?.filename.length)) === 'pdf' && (
                            <FontAwesomeIcon icon={faFilePdf} />
                        )}
                        {['png', 'jpg', 'jpeg', 'bmp'].includes(file?.filename?.substring(file?.filename.lastIndexOf(".") + 1).toLowerCase()) && (
                            <FontAwesomeIcon icon={faFileImage} />
                        )}
                        {['doc', 'docx', 'word'].includes(file?.filename?.substring(file?.filename.lastIndexOf(".") + 1).toLowerCase()) && (
                            <FontAwesomeIcon icon={faFileWord} />
                        )}
                        {['xlsx', 'xls'].includes(file?.filename?.substring(file?.filename.lastIndexOf(".") + 1).toLowerCase()) && (
                            <FontAwesomeIcon icon={faFileExcel} />
                        )}
                        {['ppt', 'pptx'].includes(file?.filename?.substring(file?.filename.lastIndexOf(".") + 1).toLowerCase()) && (
                            <FontAwesomeIcon icon={faFilePowerpoint} />
                        )}
                        {(file?.filename.substring(file?.filename.lastIndexOf(".") + 1, file?.filename.length)) === 'txt' && (
                            <FontAwesomeIcon icon={faFileText} />
                        )}
                        {(file?.filename.substring(file?.filename.lastIndexOf(".") + 1, file?.filename.length)) === 'csv' && (
                            <FontAwesomeIcon icon={faFileCsv} />
                        )}
                        {!['image', 'pdf', 'xlsx', 'xls', 'csv', 'png', 'word', 'jpg', 'jpeg', 'bmp', 'txt', 'doc', 'docx', 'ppt', 'pptx'].includes(file?.type?.split('/')[0] === 'image'
                            ? 'image'
                            : file?.filename?.substring(file?.filename.lastIndexOf(".") + 1)?.toLowerCase()
                        ) && (
                                <FontAwesomeIcon icon={faFile} />
                            )}
                    </div>
                    <div className="file-info d-flex align-items-center" >
                        <div className="name-loader d-flex align-items-center">
                            <div className="name">
                                <EllipsisWithTooltip placement="bottom">
                                    <div className="full-name" >{file.filename}</div>
                                </EllipsisWithTooltip>
                                {/* <div className="details">{file.createDate} - {file.pageno} Page</div> */}
                            </div>
                        </div>
                        <div className="formate-percentage">
                            <span className="formate d-flex justify-content-center align-items-center">{(file?.filename.substring(file?.filename.lastIndexOf(".") + 1, file?.filename.length))}</span>
                        </div>
                    </div>
                    <div className="action">

                        {/* {!this.state.bulkSelect && ( */}
                        <Dropdown className="more-action" alignRight onSelect={(event: any) => this.handleSelectFileUpload(event, file, index)}>
                            <Dropdown.Toggle className="btn-outline-primary btn btn-primary more" id="dropdown-more">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                                    <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                                    <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                                </svg>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {this.state.moreActionFileUpload2?.map(
                                    (item: any, idx: any) => (
                                        <>
                                            <Dropdown.Item
                                                eventKey={this.state.moreActionFileUpload2[idx].eventKey}
                                                key={idx}
                                                disabled={this.props.createEditPermission}
                                            >
                                                {this.state.moreActionFileUpload2[idx].name}
                                            </Dropdown.Item>
                                        </>
                                    )
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                        {/* )} */}
                    </div>
                </div>
            </li>
        </>
      ));

      const files3 = this.state.newSelectfiles2?.map((file, index) => (
        <>
            <li key={file.name}>
                <div className="d-flex align-items-center justify-content-start">
                    <div className="icon">
                        {(file?.type)?.split('/')[0] === 'image' && (
                            <FontAwesomeIcon icon={faFileImage} />
                        )}
                        {(file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) === 'pdf' && (
                            <FontAwesomeIcon icon={faFilePdf} />
                        )}
                        {(file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) === 'xlsx' && (
                            <FontAwesomeIcon icon={faFileExcel} />
                        )}
                        {(file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) === 'csv' && (
                            <FontAwesomeIcon icon={faFileCsv} />
                        )}
                        {(file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) === 'word' && (
                            <FontAwesomeIcon icon={faFileWord} />
                        )}
                        {(((file?.type)?.split('/')[0] !== 'image') &&
                            ((file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) !== 'pdf') &&
                            ((file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) !== 'xlsx')
                            && ((file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) !== 'csv')
                            && ((file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length)) !== 'word'))
                            && (
                                <FontAwesomeIcon icon={faFile} />
                            )}
                    </div>
                    <div className="file-info d-flex align-items-center">
                        <div className="name-loader d-flex align-items-center">
                            <div className="name">
                                <EllipsisWithTooltip placement="bottom">
                                    {/* <div className="full-name" onClick={() => { this.handlePreview(file) }}>{file.name}</div> */}
                                    <div className="full-name">{file.name}</div>
                                </EllipsisWithTooltip>
                            </div>
                        </div>
                        <div className="formate-percentage">
                            <span className="formate d-flex justify-content-center align-items-center">
                                {(file?.name.substring(file?.name.lastIndexOf(".") + 1, file?.name.length))}
                            </span>
                        </div>
                    </div>
                    <div className="action">
                        {/* <button className="btn-outline-primary remove-pdf more btn btn-primary" onClick={() => { this.handleSelectFileUpload("TempDelete", file, 0) }} >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"></path></svg>
                            
                        </button> */}

                        {this.state.isSpinner && (
                            <button className="btn-outline-primary remove-pdf more btn btn-primary">
                                <Spinner
                                    className="mr-2"
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            </button>
                        )}


                    </div>
                </div>
            </li>
        </>
      ));
      const {
        name,
        isDataSaving,
        description,
        serialNumber,
        modelNumber,
        manufacturer,
        purchaseCost,
        expectedLifespan,
        provider,
        terms,
        height,
        width,
        depth,
        weight,
        powerRequirements,
        energyEfficiencyRating,
        operatingRequirements,
        company,
        pointofContact,
        address,
        phone,
        email
      } = this.state;
    return (
      <div id="asset-slideout" className="pos-fxd index-1000">
        <div className="slideOut-wrapper">
          <div className="d-flex">
            <div className="back-drop" onClick={this.closeSlideOutWithConfirmation}></div>
            {/* <div className="back-drop" onClick={this.closeSlideout}></div> */}

            <Container
              fluid
              className="body-sec"
              ref={this.slideOutRef}
            >
              <div className="page-heading d-flex border-bottom-0">
                
                  <div className="user-details align-items-center mr-auto">
                      {/* <div className="location-title">{this.props?.parentstate?.assetName}</div> */}
                      
                      <div className="pos-ttl mr-auto">
                          <OverlayTrigger
                            placement="bottom"
                            defaultShow={false}
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                              <Tooltip id={"Asset-Name"} className={name?.length <= 75 ? "tootltip-hide" : ""}>
                                {name}
                              </Tooltip>
                            }
                          >
                            <AutosizeInput
                              ref={this.input}
                              className={`form-control removeBorder input-component ${this.state.bdrValue ? this.state.nameError ?  "bdr-green" :"bdr-green":""}`}
                              style={{ fontSize: 24 }}
                              injectStyles={false}
                              type="input"
                              value={name}
                              tabIndex={1}
                              onClick={() => this.handleClick()}
                              onChange={(e: any) =>{
                                  this.onFieldChange(
                                    Utils.BuildCustomEventObject(
                                      "name",
                                      e.target.value
                                    ),
                                    1
                                  )
                                }
                              }
                              onBlur={() => this.handleBlurAutoSize()}
                              placeholder={"Enter Asset Name"}
                              maxLength={100}
                            />
                          </OverlayTrigger>
                         

                      </div>
                      <span className="position-name AssetBox">Asset</span>
                  </div> 

                <div className="d-flex">
                    {/* <Dropdown className="more-action" alignRight>
                      <Dropdown.Toggle
                        className="btn-outline-primary btn btn-primary more border-0"
                        id="dropdown-more"
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                          <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                          <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                        </svg>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item></Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown> */}
                    <button
                    type="button"
                    className="btn wht-bg cross pr-0 pl-2"
                    onClick={this.closeSlideOutWithConfirmation}
                  >
                  <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                        fill="#84888C"
                      />
                    </svg>
                  </button>
                </div>
                  
              </div> 
        
              {/* <div className="info">
                <div className="form-item">
                  <div className="item-label">
                    <h6>EHID</h6>
                  </div>
                  <div className="item-value">{this.props.hotelName}</div>
                </div>
                <div className="form-item">
                  <div className="item-label">
                    <h6>Location</h6>
                  </div>
                  <div className="item-value">{this.props?.parentstate?.roomName}</div>
                </div>
                <div className="form-item">
                  <div className="item-label">
                    <h6>Asset Type</h6>
                  </div>
                  <div className="item-value">{this.props?.parentstate?.assetTypeName}</div>
                </div>
                  
              </div> */}


              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey="Details"
                activeKey={this.state.activeTab}
                onSelect={this.handleTabSelect}
              >
                <div>
                  <Nav className="nav-tabs flex-row">
                      <Nav.Item className="align-content-end">
                          <Nav.Link eventKey="Details" className="d-flex"><span> Details </span> 
                          </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                          <Nav.Link eventKey="work-orders"><span>Work Orders</span> 
                          {this.state.countLoader ? <Spinner animation="border" size="sm" variant="success" className="ml-2" /> :
                          <div className="count"><span>{this.state.count}</span></div> 
                          }   
                      </Nav.Link>
                      </Nav.Item>

                      <Nav.Item>
                          <Nav.Link eventKey="maintenance"><span>Maintenance </span>
                          <div className="count"><span>{this.refLocationMaintenance.current !== null ? this.refLocationMaintenance.current.state.tableDataLength : 0}</span></div></Nav.Link>
                      </Nav.Item>
                      <Nav.Item className="align-content-end">
                          <Nav.Link eventKey="History"><span> History </span>
                          </Nav.Link>
                      </Nav.Item>
                  </Nav>
                </div>
                <div>
                  <Tab.Content>
                      <Tab.Pane eventKey="Details">
                        <div className="asset-info">
                            <div className="info m-0 p-0">
                              <div className="mb-3">
                                <span className="section-title">Details</span>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>EHID</Form.Label>
                                  {/* <h6>EHID</h6> */}
                                </div>
                                <div className="item-value">{this.props.hotelName}</div>
                              </div>
                              <Form.Group controlId="Location" className="Location-dropdown">
                              <div className="form-item">
                                <div className="item-label">
                                    <Form.Label>Location</Form.Label>
                                </div>
                                {/* <div className="item-value">{this.props?.parentstate?.roomName}</div> */}
                                {this.state.locationTypesList.length > 0 && (
                                    <SingleSearchDropdownList
                                        // // isdisable={this.props.locationDisable}
                                        isRefresh={this.state.isRefresh}
                                        itemList={this.state.locationTypesList}
                                        handleSelectedItem={this.handleSelectedItem.bind(
                                            this,
                                            1
                                        )}
                                        defaultItem={this.state.locationTypesList}
                                        defaultText={"Location"}
                                        defaultName={this.state.locationTypesList.filter((item) => item.id === this.props?.parentstate?.roomId)[0]?.name}
                                        controlID="1"
                                        // isdisable={this.state.allWorkorderCount > 0 ? true : false}
                                        // isdisable={this.props.parentState.PageType === "locationWorkOrder" || this.props.parentState.workorderPermission === "No" ? true : false}
                                    />
                                  )}
                              </div>
                                  
                              </Form.Group>
                              <Form.Group controlId="AssetType" className="AssetType-dropdown">
                              <div className="form-item">
                              <div className="item-label">
                                  <Form.Label>Asset Type</Form.Label>
                                </div>
                                {/* <div className="item-value">{this.props?.parentstate?.assetTypeName}</div> */}
                                {this.state.assetTypes.length > 0 && (
                                <SingleSearchDropdownList
                                        // // isdisable={this.props.locationDisable}
                                        isRefresh={this.state.isRefresh}
                                        itemList={this.state.assetTypes}
                                        handleSelectedItem={this.handleSelectedItem.bind(
                                            this,
                                            2
                                        )}
                                        defaultItem={this.state.assetTypes}
                                        defaultText={"Asset Type"}
                                        defaultName={this.state.assetTypes.filter((item) => item.id === this.props?.parentstate?.assetTypeId)[0]?.name}
                                        controlID="2"
                                        // isdisable={this.props.parentState.PageType === "locationWorkOrder" || this.props.parentState.workorderPermission === "No" ? true : false}
                                    />
                                  )} 
                                </div>
                              </Form.Group>
                              <Form.Group >
                              <div className="form-item description-box">
                                <div className="item-label">
                                <Form.Label>Description</Form.Label>
                                </div>
                                  <Form.Group className="d-flex" >
                                        <Form.Control
                                            as="textarea"
                                            type="textarea"
                                            className="form-control"
                                            //maxLength={250}
                                            id="description"
                                            name="description"
                                            autoComplete="description"
                                            value= {description}
                                            placeholder="Enter description"
                                            onChange={(e) => this.descriptionChange(e)}
                                            disabled={this.props.createEditPermission}
                                        />
                                </Form.Group>
                                  </div>
                              </Form.Group>
                            </div>
                            <div className="info m-0 pt-0">
                              <div className="mb-3 mt-3">
                                <span className="section-title">Identification</span>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Serial Number</Form.Label>
                                </div>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip
                                      id={"Serial Number"}
                                      className={this.state.serialNumber && Utils.CapitalizeFirstLetter(serialNumber).length >= 28 ? "" : "tootltip-hide" }
                                    >
                                      {Utils.CapitalizeFirstLetter(serialNumber)}
                                    </Tooltip>
                                  }
                                >
                                <Form.Control
                                    type="text"
                                    className="form-control text-truncate"
                                    // tabIndex={1}
                                    maxLength={50}
                                    id="serialNumber"
                                    name="serialNumber"
                                    autoComplete="serialNumber"
                                    value={serialNumber}
                                    onChange={(e) => this.onFieldChange(e, 1)}
                                    placeholder="Enter Serial Number"
                                    disabled={this.props.createEditPermission}
                                  />
                                  </OverlayTrigger>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Model Number</Form.Label>
                                </div>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip
                                      id={"Serial Number"}
                                      className={this.state.modelNumber && Utils.CapitalizeFirstLetter(modelNumber).length >= 28 ? "" : "tootltip-hide" }
                                    >
                                      {Utils.CapitalizeFirstLetter(modelNumber)}
                                    </Tooltip>
                                  }
                                >
                                <Form.Control
                                    type="text"
                                    className="form-control text-truncate"
                                    // tabIndex={1}
                                    maxLength={100}
                                    id="modelNumber"
                                    name="modelNumber"
                                    autoComplete="modelNumber"
                                    value={modelNumber}
                                    onChange={(e) => this.onFieldChange(e, 2)}
                                    placeholder="Enter Model Number"
                                    disabled={this.props.createEditPermission}
                                  />
                                  </OverlayTrigger>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Manufacturer</Form.Label>
                                </div>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip
                                      id={"Serial Number"}
                                      className={this.state.manufacturer && Utils.CapitalizeFirstLetter(manufacturer).length >= 28 ? "" : "tootltip-hide" }
                                    >
                                      {Utils.CapitalizeFirstLetter(manufacturer)}
                                    </Tooltip>
                                  }
                                >
                                <Form.Control
                                    type="text"
                                    className="form-control text-truncate"
                                    // tabIndex={1}
                                    maxLength={100}
                                    id="manufacturer"
                                    name="manufacturer"
                                    autoComplete="manufacturer"
                                    value={manufacturer}
                                    onChange={(e) => this.onFieldChange(e, 3)}
                                    placeholder="Enter Manufacturer"
                                    disabled={this.props.createEditPermission}
                                  />
                                  </OverlayTrigger>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Installation Date</Form.Label>
                                </div>
                                      <div className={`calender-container m-0`}>
                                      <div className="d-flex calender-display svgdisplay p-0">
                                       <svg
                                          width="18"
                                          height="18"
                                          viewBox="0 0 18 18"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                          >
                                          <path d="M5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 11.25H9.75V12.75H8.25V11.25ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V12.75H11.25V11.25Z" />
                                          <path d="M3.75 16.5H14.25C15.0773 16.5 15.75 15.8273 15.75 15V6V4.5C15.75 3.67275 15.0773 3 14.25 3H12.75V1.5H11.25V3H6.75V1.5H5.25V3H3.75C2.92275 3 2.25 3.67275 2.25 4.5V6V15C2.25 15.8273 2.92275 16.5 3.75 16.5ZM14.25 6L14.2507 15H3.75V6H14.25Z" />
                                          </svg>
                                  <DatePicker
                                  value={this.state.selectedInstallationDate ? new Date(this.state.selectedInstallationDate) : null}
                                  name="installationDate"
                                  //className={`form-control scheduleInput ${row.isDuplicateEntry ? "alert-danger" : ''}`}
                                  id="shiftInstallationDate"
                                  selected={this.state.selectedInstallationDate ? new Date(this.state.selectedInstallationDate) : null}
                                  onSelect={(e: any) => this.handleSelectDate(e, "",'InstallationDate')}
                                  onChange={(e: any) => this.handleSelectDate(e,  "onChange",'InstallationDate')}
                                  autoComplete="off"
                                  placeholderText="Select Installation Date"
                                  disabled={this.props.createEditPermission}
                                />
                                  </div></div>
                                
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Manufacture Date</Form.Label>
                                </div> 
                                <div className={`calender-container m-0`}>
                                    <div className="d-flex calender-display svgdisplay p-0">
                                      <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        >
                                        <path d="M5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 11.25H9.75V12.75H8.25V11.25ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V12.75H11.25V11.25Z" />
                                        <path d="M3.75 16.5H14.25C15.0773 16.5 15.75 15.8273 15.75 15V6V4.5C15.75 3.67275 15.0773 3 14.25 3H12.75V1.5H11.25V3H6.75V1.5H5.25V3H3.75C2.92275 3 2.25 3.67275 2.25 4.5V6V15C2.25 15.8273 2.92275 16.5 3.75 16.5ZM14.25 6L14.2507 15H3.75V6H14.25Z" />
                                        </svg>
                                <DatePicker
                                  value={ new Date("2025-02-01") }
                                  name="manufactureDate"
                                  //className={`form-control scheduleInput ${row.isDuplicateEntry ? "alert-danger" : ''}`}
                                  id="shiftManufactureDate"
                                  selected={this.state.selectedManufactureDate ? new Date(this.state.selectedManufactureDate) : null}
                                  onSelect={(e: any) => this.handleSelectDate(e,  "",'ManufactureDate')}
                                  onChange={(e: any) => this.handleSelectDate(e,  "onChange",'ManufactureDate')}
                                  autoComplete="off"
                                  placeholderText="Select Manufacture Date"
                                  disabled={this.props.createEditPermission}
                              />
                              </div></div>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Purchase Date</Form.Label>
                                </div> 
                                <div className={`calender-container m-0`}>
                                    <div className="d-flex calender-display svgdisplay p-0">
                                      <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        >
                                        <path d="M5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 11.25H9.75V12.75H8.25V11.25ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V12.75H11.25V11.25Z" />
                                        <path d="M3.75 16.5H14.25C15.0773 16.5 15.75 15.8273 15.75 15V6V4.5C15.75 3.67275 15.0773 3 14.25 3H12.75V1.5H11.25V3H6.75V1.5H5.25V3H3.75C2.92275 3 2.25 3.67275 2.25 4.5V6V15C2.25 15.8273 2.92275 16.5 3.75 16.5ZM14.25 6L14.2507 15H3.75V6H14.25Z" />
                                        </svg>
                                <DatePicker
                                  value={this.state.selectedPurchaseDate ? new Date(this.state.selectedPurchaseDate) : null}
                                  name="purchaseDate"
                                  //className={`form-control scheduleInput ${row.isDuplicateEntry ? "alert-danger" : ''}`}
                                  id="shiftPurchaseDate"
                                  selected={this.state.selectedPurchaseDate ? new Date(this.state.selectedPurchaseDate) : null}
                                  onSelect={(e: any) => this.handleSelectDate(e, "",'PurchaseDate')}
                                  onChange={(e: any) => this.handleSelectDate(e, "onChange",'PurchaseDate')}
                                  autoComplete="off"
                                  placeholderText="Select Purchase Date"
                                  disabled={this.props.createEditPermission}
                              />
                              </div></div>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Purchase Cost</Form.Label>
                                </div>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip
                                      id={"Serial Number"}
                                      className={this.state.purchaseCost && Utils.CapitalizeFirstLetter(purchaseCost).length >= 28 ? "" : "tootltip-hide" }
                                    >
                                      {Utils.CapitalizeFirstLetter(purchaseCost)}
                                    </Tooltip>
                                  }
                                >
                                <Form.Control
                                    type="text"
                                    className="form-control text-truncate"
                                    // tabIndex={1}
                                    maxLength={100}
                                    id="purchaseCost"
                                    name="purchaseCost"
                                    autoComplete="purchaseCost"
                                    value={purchaseCost}
                                    onChange={(e) => this.onFieldChange(e, 4)}
                                    placeholder="Enter Purchase Cost"
                                    disabled={this.props.createEditPermission}
                                  />
                                  </OverlayTrigger>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Expected Lifespan</Form.Label>
                                </div>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip
                                      id={"Serial Number"}
                                      className={this.state.expectedLifespan && Utils.CapitalizeFirstLetter(expectedLifespan).length >= 28 ? "" : "tootltip-hide" }
                                    >
                                      {Utils.CapitalizeFirstLetter(expectedLifespan)}
                                    </Tooltip>
                                  }
                                >
                                <Form.Control
                                    type="text"
                                    className="form-control text-truncate"
                                    // tabIndex={1}
                                    maxLength={100}
                                    id="expectedLifespan"
                                    name="expectedLifespan"
                                    autoComplete="expectedLifespan"
                                    value={expectedLifespan}
                                    onChange={(e) => this.onFieldChange(e, 5)}
                                    placeholder="Enter Expected Lifespan"
                                    disabled={this.props.createEditPermission}
                                  />
                                  </OverlayTrigger>
                              </div>
                            </div>
                            <div className="info m-0 pt-0">
                              <div className="mb-3 mt-3">
                                <span className="section-title">Warranty</span>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Start Date</Form.Label>
                                </div>
                                <div className={`calender-container m-0`}>
                                    <div className="d-flex calender-display svgdisplay p-0">
                                      <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        >
                                        <path d="M5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 11.25H9.75V12.75H8.25V11.25ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V12.75H11.25V11.25Z" />
                                        <path d="M3.75 16.5H14.25C15.0773 16.5 15.75 15.8273 15.75 15V6V4.5C15.75 3.67275 15.0773 3 14.25 3H12.75V1.5H11.25V3H6.75V1.5H5.25V3H3.75C2.92275 3 2.25 3.67275 2.25 4.5V6V15C2.25 15.8273 2.92275 16.5 3.75 16.5ZM14.25 6L14.2507 15H3.75V6H14.25Z" />
                                        </svg>
                                <DatePicker
                                  value={this.state.selectedStartDate ? new Date(this.state.selectedStartDate) : null}
                                  name="startDate"
                                  //className={`form-control scheduleInput ${row.isDuplicateEntry ? "alert-danger" : ''}`}
                                  id="shiftStartDate"
                                  selected={this.state.selectedStartDate ? new Date(this.state.selectedStartDate) : null}
                                  onSelect={(e: any) => this.handleSelectDate(e, "",'StartDate')}
                                  onChange={(e: any) => this.handleSelectDate(e, "onChange",'StartDate')}
                                  autoComplete="off"
                                  placeholderText="Select Warranty Start Date"
                                    disabled={this.props.createEditPermission}
                                  maxDate={this.state.selectedEndDate ? new Date(this.state.selectedEndDate) : null}
                                />
                                </div></div>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>End Date</Form.Label>
                                </div>
                                <div className={`calender-container m-0`}>
                                    <div className="d-flex calender-display svgdisplay p-0">
                                      <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        >
                                        <path d="M5.25 8.25H6.75V9.75H5.25V8.25ZM5.25 11.25H6.75V12.75H5.25V11.25ZM8.25 8.25H9.75V9.75H8.25V8.25ZM8.25 11.25H9.75V12.75H8.25V11.25ZM11.25 8.25H12.75V9.75H11.25V8.25ZM11.25 11.25H12.75V12.75H11.25V11.25Z" />
                                        <path d="M3.75 16.5H14.25C15.0773 16.5 15.75 15.8273 15.75 15V6V4.5C15.75 3.67275 15.0773 3 14.25 3H12.75V1.5H11.25V3H6.75V1.5H5.25V3H3.75C2.92275 3 2.25 3.67275 2.25 4.5V6V15C2.25 15.8273 2.92275 16.5 3.75 16.5ZM14.25 6L14.2507 15H3.75V6H14.25Z" />
                                        </svg>
                                <DatePicker
                                  value={this.state.selectedEndDate ? new Date(this.state.selectedEndDate) : null}
                                  name="endtDate"
                                  //className={`form-control scheduleInput ${row.isDuplicateEntry ? "alert-danger" : ''}`}
                                  id="shiftEndtDate"
                                  selected={this.state.selectedEndDate ? new Date(this.state.selectedEndDate) : null}
                                  onSelect={(e: any) => this.handleSelectDate(e, "",'EndDate')}
                                  onChange={(e: any) => this.handleSelectDate(e, "onChange",'EndDate')}
                                  autoComplete="off"
                                  placeholderText="Select Warranty End Date"
                                  disabled={this.props.createEditPermission}
                                  onFocus={(e) => e.target.click()}
                                  minDate={this.state.selectedStartDate ? new Date(new Date(this.state.selectedStartDate).setDate(new Date(this.state.selectedStartDate).getDate() + 1)) : null}
                                />
                                </div></div>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Provider</Form.Label>
                                </div>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip
                                      id={"Serial Number"}
                                      className={this.state.provider && Utils.CapitalizeFirstLetter(provider).length >= 28 ? "" : "tootltip-hide" }
                                    >
                                      {Utils.CapitalizeFirstLetter(provider)}
                                    </Tooltip>
                                  }
                                >
                                <Form.Control
                                    type="text"
                                    className="form-control text-truncate"
                                    // tabIndex={1}
                                    maxLength={100}
                                    id="provider"
                                    name="provider"
                                    autoComplete="provider"
                                    value={provider}
                                    onChange={(e) => this.onFieldChange(e, 6)}
                                    placeholder="Enter Warranty Provider"
                                    disabled={this.props.createEditPermission}
                                  />
                                  </OverlayTrigger>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Terms</Form.Label>
                                </div>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip
                                      id={"Serial Number"}
                                      className={this.state.terms && Utils.CapitalizeFirstLetter(terms).length >= 28 ? "" : "tootltip-hide" }
                                    >
                                      {Utils.CapitalizeFirstLetter(terms)}
                                    </Tooltip>
                                  }
                                >
                                <Form.Control
                                    type="text"
                                    className="form-control text-truncate"
                                    // tabIndex={1}
                                    maxLength={100}
                                    id="terms"
                                    name="terms"
                                    autoComplete="terms"
                                    value={terms}
                                    onChange={(e) => this.onFieldChange(e, 7)}
                                    placeholder="Enter Warranty Terms"
                                    disabled={this.props.createEditPermission}
                                  />
                                  </OverlayTrigger>
                              </div>
                                <Form.Label>Documents</Form.Label>
                                <div className="mt-2">
                                <Dropzone
                                    disabled={this.props.createEditPermission}
                                  onDrop={(files) => this.onDrop(files, 1)}
                              // accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                              >
                                  {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                                      <>
                                          <section className={isDragActive ? "container upload-area default drag-active " : "container upload-area default"}>

                                              {!this.state.bulkSelect && (

                                                  <div {...getRootProps({
                                                      className: 'dropzone d-flex align-items-center',
                                                      onClick: (this.state.newSelectfiles.length > 0 || this.state.savedfiles.length > 0) ?
                                                          event => event.stopPropagation() : event => event
                                                  })}>
                                                      <input {...getInputProps()} />
                                                      {(this.state.newSelectfiles.length < 1 && this.state.savedfiles.length < 1) && (
                                                          <p>Drag and drop or <span>browse for a file</span></p>
                                                      )}
                                                      {(this.state.newSelectfiles.length > 0 || this.state.savedfiles.length > 0) && isDragActive && (
                                                          <p>Drag and drop files here to upload.</p>
                                                      )}
                                                      {/* {!isDragActive && (<p>Drag and drop or <span>browse files</span> to upload</p>)} */}

                                                  </div>
                                              )}
                                              {(this.state.newSelectfiles.length > 0 || this.state.savedfiles.length > 0) && (
                                                  <aside className="d-flex flex-column">
                                                      <ul className="p-0 ml-3 mr-3">{files1}</ul>
                                                      <ul className="p-0 ml-3 mr-3">{files}</ul>
                                                  </aside>
                                              )}
                                          </section>
                                          {(!this.state.bulkSelect && (this.state.newSelectfiles.length > 0 || this.state.savedfiles.length > 0)) && (
                                              <div className="upload-link mrgn-top">
                                                  <button type="button" className="btn p-0 wht-bg link-btn mr-auto" >Add Attachment</button>
                                                  <Form.Control id="formControlsFile" type="file" multiple onChange={(event: any) => this.onFileChange(event, 1)} disabled={this.props.createEditPermission} 
                                                      accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml" />
                                              </div>
                                          )}
                                      </>
                                  )}
                                </Dropzone>
                                </div>
                            </div>
                            <div className="info m-0 pt-0">
                              <div className="mb-3 mt-3">
                                <span className="section-title">Technical Specifications</span>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Dimensions</Form.Label>
                                </div>
                                <div className="dimensionsbox d-flex align-items-center">
                                  <b className="mr-1">H</b>
                                  <Form.Control
                                      type="text"
                                      className="form-control"
                                      // tabIndex={1}
                                      maxLength={50}
                                      id="height"
                                      name="height"
                                      autoComplete="height"
                                      value={height}
                                      onChange={(e) => this.onFieldChange(e, 8)}
                                      placeholder="Enter Height"
                                      disabled={this.props.createEditPermission}
                                    />
                                    <span className="mr-2 text-muted">x</span>
                                    <b className="mr-1">W</b>
                                    <Form.Control
                                      type="text"
                                      className="form-control"
                                      // tabIndex={1}
                                      maxLength={50}
                                      id="width"
                                      name="width"
                                      autoComplete="width"
                                      value={width}
                                      onChange={(e) => this.onFieldChange(e, 9)}
                                      placeholder="Enter Width"
                                      disabled={this.props.createEditPermission}
                                    />
                                    <span className="mr-2 text-muted">x</span>
                                    <b className="mr-1">D</b>
                                    <Form.Control
                                      type="text"
                                      className="form-control"
                                      // tabIndex={1}
                                      maxLength={50}
                                      id="depth"
                                      name="depth"
                                      autoComplete="depth"
                                      value={depth}
                                      onChange={(e) => this.onFieldChange(e, 10)}
                                      placeholder="Enter Depth"
                                      disabled={this.props.createEditPermission}
                                    />
                                </div>
                               
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                  <Form.Label>Weight</Form.Label>
                                </div>
                                <Form.Control
                                    type="text"
                                    className="form-control"
                                    // tabIndex={1}
                                    maxLength={50}
                                    id="weight"
                                    name="weight"
                                    autoComplete="weight"
                                    value={weight}
                                    onChange={(e) => this.onFieldChange(e, 11)}
                                    placeholder="Enter Weight"
                                    disabled={this.props.createEditPermission}
                                  />
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Power Requirements</Form.Label>
                                </div>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip
                                      id={"Serial Number"}
                                      className={this.state.powerRequirements && Utils.CapitalizeFirstLetter(powerRequirements).length >= 28 ? "" : "tootltip-hide" }
                                    >
                                      {Utils.CapitalizeFirstLetter(powerRequirements)}
                                    </Tooltip>
                                  }
                                >
                                <Form.Control
                                    type="text"
                                    className="form-control text-truncate"
                                    // tabIndex={1}
                                    maxLength={100}
                                    id="powerRequirements"
                                    name="powerRequirements"
                                    autoComplete="powerRequirements"
                                    value={powerRequirements}
                                    onChange={(e) => this.onFieldChange(e, 12)}
                                    placeholder="Enter Power Requirements"
                                    disabled={this.props.createEditPermission}
                                  />
                                  </OverlayTrigger>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Energy Efficiency Rating</Form.Label>
                                </div>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip
                                      id={"Serial Number"}
                                      className={this.state.energyEfficiencyRating && Utils.CapitalizeFirstLetter(energyEfficiencyRating).length >= 28 ? "" : "tootltip-hide" }
                                    >
                                      {Utils.CapitalizeFirstLetter(energyEfficiencyRating)}
                                    </Tooltip>
                                  }
                                >
                                <Form.Control
                                    type="text"
                                    className="form-control text-truncate"
                                    // tabIndex={1}
                                    maxLength={50}
                                    id="energyEfficiencyRating"
                                    name="energyEfficiencyRating"
                                    autoComplete="energyEfficiencyRating"
                                    value={energyEfficiencyRating}
                                    onChange={(e) => this.onFieldChange(e, 13)}
                                    placeholder="Enter Energy Efficiency Rating"
                                    disabled={this.props.createEditPermission}
                                  />
                                  </OverlayTrigger>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Operating Requirements</Form.Label>
                                </div>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip
                                      id={"Serial Number"}
                                      className={this.state.operatingRequirements && Utils.CapitalizeFirstLetter(operatingRequirements).length >= 28 ? "" : "tootltip-hide" }
                                    >
                                      {Utils.CapitalizeFirstLetter(operatingRequirements)}
                                    </Tooltip>
                                  }
                                >
                                <Form.Control
                                    type="text"
                                    className="form-control text-truncate"
                                    // tabIndex={1}
                                    maxLength={100}
                                    id="operatingRequirements"
                                    name="operatingRequirements"
                                    autoComplete="operatingRequirements"
                                    value={operatingRequirements}
                                    onChange={(e) => this.onFieldChange(e, 14)}
                                    placeholder="Enter Operating Requirements"
                                    disabled={this.props.createEditPermission}
                                  />
                                  </OverlayTrigger>
                              </div>
                                <Form.Label>Documents</Form.Label>
                                <div className="mt-2">
                                <Dropzone
                                  disabled={this.props.createEditPermission}
                                  onDrop={(files) => this.onDrop(files, 2)}
                              // accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                              >
                                  {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                                      <>
                                          <section className={isDragActive ? "container upload-area default drag-active " : "container upload-area default"}>
                                              {!this.state.bulkSelect && (
                                                  <div {...getRootProps({
                                                      className: 'dropzone d-flex align-items-center',
                                                      onClick: (this.state.newSelectfiles2.length > 0 || this.state.savedfiles2.length > 0) ?
                                                          event => event.stopPropagation() : event => event
                                                  })}>
                                                      <input {...getInputProps()} />
                                                      {(this.state.newSelectfiles2.length < 1 && this.state.savedfiles2.length < 1) && (
                                                          <p>Drag and drop or <span>browse for a file</span></p>
                                                      )}
                                                      {(this.state.newSelectfiles2.length > 0 || this.state.savedfiles2.length > 0) && isDragActive && (
                                                          <p>Drag and drop files here to upload.</p>
                                                      )}
                                                  </div>

                                              )}
                                              {(this.state.newSelectfiles2.length > 0 || this.state.savedfiles2.length > 0) && (
                                                  <aside className="d-flex flex-column">
                                                      <ul className="p-0 ml-3 mr-3">{files2}</ul>
                                                      <ul className="p-0 ml-3 mr-3">{files3}</ul>
                                                  </aside>
                                              )}
                                          </section>
                                          {(!this.state.bulkSelect && (this.state.newSelectfiles2.length > 0 || this.state.savedfiles2.length > 0)) && (
                                              <div className="upload-link mrgn-top">
                                                  <button type="button" className="btn p-0 wht-bg link-btn mr-auto" >Add Attachment</button>
                                                  <Form.Control id="formControlsFile" type="file" multiple onChange={(event: any) => this.onFileChange(event, 2)}  disabled={this.props.createEditPermission} 
                                                      accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml" />

                                              </div>
                                          )}
                                      </>
                                  )}
                                </Dropzone>
                                </div>
                            </div>
                            <div className="info m-0 pt-0">
                            <div className="mb-3 mt-3">
                                <span className="section-title">Service Provider</span>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Company</Form.Label>
                                </div>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip
                                      id={"Serial Number"}
                                      className={this.state.company && Utils.CapitalizeFirstLetter(company).length >= 28 ? "" : "tootltip-hide" }
                                    >
                                      {Utils.CapitalizeFirstLetter(company)}
                                    </Tooltip>
                                  }
                                >
                                <Form.Control
                                    type="text"
                                    className="form-control text-truncate"
                                    // tabIndex={1}
                                    maxLength={100}
                                    id="company"
                                    name="company"
                                    autoComplete="company"
                                    value={company}
                                    onChange={(e) => this.onFieldChange(e, 15)}
                                    placeholder="Enter Company"
                                    disabled={this.props.createEditPermission}
                                  />
                                  </OverlayTrigger>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Point of Contact</Form.Label>
                                </div>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip
                                      id={"Serial Number"}
                                      className={this.state.pointofContact && Utils.CapitalizeFirstLetter(pointofContact).length >= 28 ? "" : "tootltip-hide" }
                                    >
                                      {Utils.CapitalizeFirstLetter(pointofContact)}
                                    </Tooltip>
                                  }
                                >
                                <Form.Control
                                    type="text"
                                    className="form-control text-truncate"
                                    // tabIndex={1}
                                    maxLength={100}
                                    id="pointofContact"
                                    name="pointofContact"
                                    autoComplete="pointofContact"
                                    value={pointofContact}
                                    onChange={(e) => this.onFieldChange(e, 16)}
                                    placeholder="Enter Point of Contact"
                                    disabled={this.props.createEditPermission}
                                  />
                                  </OverlayTrigger>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Address</Form.Label>
                                </div>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip
                                      id={"Serial Number"}
                                      className={this.state.address && Utils.CapitalizeFirstLetter(address).length >= 28 ? "" : "tootltip-hide" }
                                    >
                                      {Utils.CapitalizeFirstLetter(address)}
                                    </Tooltip>
                                  }
                                >
                                <Form.Control
                                    type="text"
                                    className="form-control text-truncate"
                                    // tabIndex={1}
                                    maxLength={100}
                                    id="address"
                                    name="address"
                                    autoComplete="address"
                                    value={address}
                                    onChange={(e) => this.onFieldChange(e, 17)}
                                    placeholder="Enter Address"
                                    disabled={this.props.createEditPermission}
                                  />
                                  </OverlayTrigger>
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Phone</Form.Label>
                                </div>
                                <Form.Control
                                    type="text"
                                    className="form-control"
                                    // tabIndex={1}
                                    maxLength={100}
                                    id="phone"
                                    name="phone"
                                    autoComplete="phone"
                                    value={phone}
                                    onChange={(e) => this.onFieldChange(e, 18)}
                                    placeholder="Enter Phone"
                                    disabled={this.props.createEditPermission}
                                  />
                              </div>
                              <div className="form-item">
                                <div className="item-label">
                                <Form.Label>Email</Form.Label>
                                </div>
                                <div>
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={
                                    <Tooltip
                                      id={"Serial Number"}
                                      className={this.state.email && Utils.CapitalizeFirstLetter(email).length >= 28 ? "" : "tootltip-hide" }
                                    >
                                      {Utils.CapitalizeFirstLetter(email)}
                                    </Tooltip>
                                  }
                                >
                                <Form.Control
                                    type="text"
                                    className= {`form-control text-truncate ${this.state.errors.email ? "border border-danger pl-2" : ""}`}  
                                    // tabIndex={1}
                                    maxLength={100}
                                    id="email"
                                    name="email"
                                    autoComplete="email"
                                    value={email}
                                    onChange={(e) => this.onFieldChange(e, 19)}
                                    placeholder="Enter Email"
                                    disabled={this.props.createEditPermission}
                                  />
                              </OverlayTrigger>
                                  {this.state.errors.email && (
                                    <div className="text-danger mt-1">{this.state.errors.email}</div>
                                  )}
                                  </div>
                              </div>
                            </div>
                        </div>
                        
                      </Tab.Pane>
                      <Tab.Pane eventKey="work-orders">
                      {/* <BootstrapTable
                      keyField="workOrderID"
                      data={this.state.tableData}
                      columns={columns}
                      search
                      hover
                    /> */}
                    <AssetWorkOrder 
                    assetId={this.props.parentstate.assetId}
                    ref={this.refLocationWorkOrder} countUpdate={this.countUpdate}
                    closeLocationSlideOut={this.closeLocationSlideOut} parentData={this.state} changesAfterSave={this.changesAfterSave}></AssetWorkOrder>
                  
                      </Tab.Pane>
                  
                      <Tab.Pane eventKey="maintenance">
                      <AssetMaintenance roomId={this.props.parentstate.roomId} ref={this.refLocationMaintenance} parentData={this.state}></AssetMaintenance>
                      </Tab.Pane>
                      <Tab.Pane eventKey="History">
                        <div className="d-flex justify-content-between">
                              <AssetHistoryBox
                                  ref={(ref) => (this.childHistoryBox = ref)}
                                  hotelid={this.state.hidValue}
                                  assetId={Number(this.props.parentstate.assetId)}
                                  entryType={this.state.pageType}
                                  precommentlist={this.state.htmlHistory}
                                  parentState={this.state}
                              />
                              <div className="Export-link mrgn-top">
                                <button type="button" className="btn p-0 wht-bg link-btn mr-auto" onClick={this.handleExport} >
                                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 16 18" fill="none">
                                  <path d="M15 6H11V0H5V6H1L8 14L15 6ZM0 16H16V18H0V16Z" fill="#2CAF92"/>
                                </svg>
                                Export</button>
                              </div>
                        </div>
                      </Tab.Pane>
                    
                  </Tab.Content>
                </div>
                {this.state.isSlideOut && (
                  <div className="asset-workorder-slideOut">
                    <div className="breadcrumb-bar">
                      <Button onClick={this.closeworkorderSlideout}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="22" viewBox="0 0 26 22" fill="none">
                        <path d="M25.116 3.1328L22.4208 0.4375L11.6396 11.2187L22.4208 22L25.116 19.3045L17.0302 11.2187L25.116 3.1328Z" fill="#2CAF92"/>
                        <path d="M11.6396 0.4375L14.3349 3.1328L6.24901 11.2187L14.3349 19.3045L11.6396 21.9998L0.858398 11.2187L11.6396 0.4375Z" fill="#2CAF92"/>
                      </svg>
                        <span>Back to {this.props?.parentstate?.assetName}</span>
                        
                      </Button>
                    </div>
                    <WorkOrderSlideOut
                      assetDisable={true}
                      locationDisable={true}
                      ref={this.wororderSlideOut}
                       closeWorkSlideOut={this.closeworkorderSlideout}
                      parentState={this.state}
                      parentRowData={this.state.parentRowData}
                      // workOrderStatusUpdate={this.workOrderStatusUpdate}
                      closeLocationSlideOut={this.closeSlideOut}
                    // changesOfSlideOut={this.changesOfSlideOut}
                    refeshTable={this.refeshTable}     
                    slideOutClosewithDiscardChanges={this.slideOutClosewithDiscardChanges}     
                    // slideOutClosewithoutChanges={this.slideOutClosewithoutChanges} 
                    closeworkorderSlideout={this.closeworkorderSlideout}                    
                    />
                  </div>

                )}
              </Tab.Container> 
                {/* <div className="comments text-break position-relative mt-4">
                <Tabs defaultActiveKey="History">
                    <Tab eventKey="History" title="History">
                        <div className="d-flex justify-content-between">
                            <AssetHistoryBox
                                ref={(ref) => (this.childHistoryBox = ref)}
                                hotelid={this.state.hidValue}
                                assetId={Number(this.props.parentstate.assetId)}
                                entryType={this.state.pageType}
                                precommentlist={this.state.htmlHistory}
                                parentState={this.state}
                            />
                            <div className="Export-link mrgn-top">
                              <button type="button" className="btn p-0 wht-bg link-btn mr-auto" onClick={this.handleExport} >
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 16 18" fill="none">
                                <path d="M15 6H11V0H5V6H1L8 14L15 6ZM0 16H16V18H0V16Z" fill="#2CAF92"/>
                              </svg>
                              Export</button>
                            </div>
                        </div>
                    </Tab>            
                </Tabs>
              </div> */}
            </Container>
            {this.state.changeValue && (
                        <div className="strip-wrapper">
                          <div className="fixed-action px-3 pb-2 h-auto">
                            <div className="d-flex align-items-center flex-wrap forecast-action-strip">
                              <div className="mr-auto message">
                                <span>
                                  You have made changes to this Asset. Do
                                  you want to save and continue ?{" "}
                                </span>
                              </div>

                              <button
                                type="button"
                                className="btn btn-primary border-0 btn-discard btn-changes-discard"
                                onClick={() => this.disccardChanges()}
                              >
                                Discard
                              </button>

                              <button
                                disabled={isDataSaving}
                                type="button"
                                className="save-btn btn btn-primary mr-0"
                                onClick={this.handleSave}
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
          </div>
           
        </div>
      </div>
    );
  }
}
